import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CommunicationObjectList.html?raw';
import lang from 'dojo/_base/lang';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import FinderBaseV2 from '../../WidgetCollection/FinderBase/FinderBaseV2';
import { EntityHelpers } from "../../more/Helpers";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';

interface ListsData {
    all: { layouts: Array<StaticTable.Layout>, list: Array<ApiEntity> },
    creator: { layouts: Array<StaticTable.Layout>, list: Array<ApiEntity> },
    sender: { layouts: Array<StaticTable.Layout>, list: Array<ApiEntity> },
    receiver: { layouts: Array<StaticTable.Layout>, list: Array<ApiEntity> },
    cc: { layouts: Array<StaticTable.Layout>, list: Array<ApiEntity> },
    bcc: { layouts: Array<StaticTable.Layout>, list: Array<ApiEntity> }
}

class CommunicationObjectList extends compose(_uiFrameMixin) {
    templateString: any = template;
    
    private pageStack: MdsLax<InstanceType<typeof PageStack>>;

    private finderAll: MdsLax<InstanceType<typeof FinderBaseV2>>;
    private finderCreator: MdsLax<InstanceType<typeof FinderBaseV2>>;
    private finderSender: MdsLax<InstanceType<typeof FinderBaseV2>>;
    private finderReceiver: MdsLax<InstanceType<typeof FinderBaseV2>>;
    private finderCc: MdsLax<InstanceType<typeof FinderBaseV2>>;
    private finderBcc: MdsLax<InstanceType<typeof FinderBaseV2>>;

    private mode: "userHub" | "addressWizard" = "userHub";
    private contextAddressId: string = null;

    constructor(mode: "userHub" | "addressWizard", contextAddressId: string = null) {
        super(...(arguments as unknown as []));
        this.mode = mode;
        this.contextAddressId = contextAddressId;
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<any>) {

        cell.contentnode.innerHTML = cell.value;
        switch (cell.name) {
            default:
                return false;
        }
    }
    private setupFilters() {
        let config = [
            { finder: this.finderAll, name: "all" },
            { finder: this.finderCreator, name: "creator" },
            { finder: this.finderSender, name: "sender" },
            { finder: this.finderReceiver, name: "receiver" },
            { finder: this.finderCc, name: "cc" },
            { finder: this.finderBcc, name: "bcc" },
        ]

        config.forEach(conf => {
            
            let additionalRequestData: Array<{ name: string, value: any, setAsNewParameter?: boolean }> = [];
            additionalRequestData.push({ name: "mode", value: this.mode });
            additionalRequestData.push({ name: "contextAddressId", value: this.contextAddressId });
            additionalRequestData.push({ name: "finder", value: conf.name });

            conf.finder.RequestManager.handleAs = "jsonWithDate";
            conf.finder.setupFinderWithCallfunctions(
                "Webtool_API_CommunicationObjectList__Finder_GetConfig",
                "Webtool_API_CommunicationObjectList__Finder_GetResults",
                lang.hitch(this, this.onTableRowClick),
                lang.hitch(this, this.tableFormatter),
                null,
                additionalRequestData
            )
        });

        //setTimeout(() => { this.StandbyStop() }, 1500);
    }

    private onTableRowClick(row: StaticTable.StaticTableRow<ApiEntity>, rowGroup: StaticTable.StaticTableRowGroup<ApiEntity>, evt: Event) {
        
        this.StandbyStart();

        EntityHelpers.openEntityView({
            entityClass: "email_transmission",
            entityId: rowGroup.entity.ID,
            label: null,
            contextName: `CommunicationObjectList_${this.mode}`,
        });

        this.StandbyStop();
    }

    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.pageStack.showPage("all", true);

        this.StandbyStart()

        this.setupFilters();

        this.finderAll.on("tableReady", (table: MdsLax<InstanceType<typeof StaticTable>>) => {
            console.debug("TABLE READY", table.getData())
            this.emit("hasContent", { hasContent: table.getData().length > 0 });
            this.StandbyStop()
        })
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CommunicationObjectList);